import reducer from './reducer'
import * as ProcessesOperations from './operations'
import * as ProcessesUtils from './utils'
import * as ProcessesTypes from './types'
import * as ProcessesActions from './actions'

export { ProcessesOperations, ProcessesUtils, ProcessesTypes, ProcessesActions }

export default reducer
